<template>
  <div class="nx-dashboard-shortcut__content">
    <v-btn class="v-btn"
           block
           flat
           :disabled="disabled"
           @click="openDialog('wizard')">
      <v-icon color="nx-neutral-200" large>{{ icon }}</v-icon>
      <v-card-text>{{ text }}</v-card-text>
    </v-btn>
    <nx-entity-wizard
      v-if="dialogState.wizard.render"
      :active="dialogState.wizard.active"
      :entity="entity"
      enable-create-and-continue
      @dismiss="closeDialog('wizard')"
      @entityCreated="entityCreated">
    </nx-entity-wizard>
  </div>
</template>

<script>
import NxEntityWizard from '@/modules/entity/wizard/Wizard.vue';
import ManageDialogs, { initDialog } from '@/mixins/manage-dialogs';

export default {
  name: 'nx-dashboard-shortcuts-create-entity',
  mixins: [ManageDialogs],
  props: {
    entity: String,
    icon: String,
    text: String,
    disabled: Boolean,
  },
  components: {
    NxEntityWizard,
  },
  data() {
    return {
      dialogState: {
        wizard: initDialog(),
      },
      entityWizard: '',
      showWizard: false,
    };
  },
  methods: {
    openWizard(entityWizard) {
      this.entityWizard = entityWizard;
      this.$nextTick(() => {
        this.showWizard = true;
      });
    },
    closeWizard() {
      this.entityWizard = '';
      this.showWizard = false;
    },
    entityCreated(entity) {
      if (entity
        && entity.route
        && entity.navigateToEntityEditor
      ) {
        this.$router.push(entity.route);
      }
    },
  },
};
</script>
